import { useDownloadFile } from '@features/invoices/hooks/use-download-file/useDownloadFile';

import type {
  UseDownloadInvoiceParams,
  UseDownloadInvoiceReturn,
} from './useDownloadInvoice.types';

export function useDownloadInvoice({
  accountReceivableId,
  transactionNumber,
}: UseDownloadInvoiceParams): UseDownloadInvoiceReturn {
  return useDownloadFile({
    id: accountReceivableId,
    filename: `invoice-${transactionNumber || accountReceivableId}.pdf`,
    errorMessage: 'Downloading the invoice failed, please try again.',
  });
}
